import type { CSSProperties, ReactNode } from "react";

type Props = {
  title?: string;
  description?: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
  footer?: ReactNode;
  style?: CSSProperties;
};

export function Card({
  title,
  description,
  action,
  children,
  className = "",
  bodyClassName = "",
  footer,
  style,
}: Props) {
  const hasHeader = title || description || action;

  return (
    <section className={`card ${className}`.trim()} style={style}>
      {hasHeader && (
        <div className="card__header">
          <div className="card__header-text">
            {title && <h2 className="card__title">{title}</h2>}
            {description && <p className="card__description">{description}</p>}
          </div>
          {action && <div className="card__action">{action}</div>}
        </div>
      )}
      <div className={`card__body ${bodyClassName}`.trim()}>{children}</div>
      {footer && <div className="card__footer">{footer}</div>}
    </section>
  );
}
